import { print } from 'graphql';

import getMetricSeriesByCourseQuery from '~/shared/graphql-queries/metric-values/get-metric-series-by-course-query';
import saveManyMetricValuesMutation from '~/shared/graphql-queries/metric-values/save-many-metric-values-mutation';
import type { BuilderType } from '~/types';

type SaveManyMetricValuesArgs = Readonly<{
  record?: Record<string, unknown>;
}>;

type GetMetricSeriesByCourseArgs = Readonly<{
  course?: string;
  courseCategory?: string;
  creator?: string;
  isVisibleToStudent?: boolean;
}>;

type GetMetricSeriesByCourseResponse = Readonly<{
  data?: {
    getMetricSeriesByCourse?: Record<string, unknown>;
  };
}>;

type GetMetricSeriesByCourseResult = Readonly<Record<string, unknown>>;

const transformMetricSeriesResponse = (response: GetMetricSeriesByCourseResponse): GetMetricSeriesByCourseResult => {
  return response?.data?.getMetricSeriesByCourse ?? {};
};

export const metricValuesTagTypes = ['metric-values'] as const;

export const getMetricValuesQuery = (builder: BuilderType) => {
  return {
    saveManyMetricValues: builder.mutation<unknown, SaveManyMetricValuesArgs>({
      query: (args) => ({
        url: '',
        method: 'POST',
        body: JSON.stringify({
          query: print(saveManyMetricValuesMutation),
          variables: {
            record: args?.record,
          },
        }),
      }),
      invalidatesTags: ['metric-values'],
    }),

    getMetricSeriesByCourse: builder.query<GetMetricSeriesByCourseResult, GetMetricSeriesByCourseArgs>({
      query: (args) => ({
        url: '',
        method: 'POST',
        body: JSON.stringify({
          query: print(getMetricSeriesByCourseQuery),
          variables: {
            course: args?.course,
            courseCategory: args?.courseCategory,
            creator: args?.creator,
            isVisibleToStudent: args?.isVisibleToStudent,
          },
        }),
      }),
      transformResponse: transformMetricSeriesResponse,
      providesTags: ['metric-values'],
    }),
  };
};
